import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Route, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GridColumnsConfiguration } from 'src/app/components/shared/grid/grid.component';
import { ModalSettingsCameraComponent } from '../modal-settings-camera/modal-settings-camera.component';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';

@Component({
  selector: 'neoris-settings-camera',
  templateUrl: './settings-camera.component.html',
  styleUrl: './settings-camera.component.css'
})
export class SettingsCameraComponent implements OnInit {
arrayData: any[] = []
today = new Date();
  month = this.today.getUTCMonth();
  year = this.today.getUTCFullYear();
  day = this.today.getUTCDate()
  private onLanChange:Subscription
  strTranslate:string = ''

 
  constructor(private route:Router,
    private dialog: MatDialog,
    private controltowerservice:ControltowerService,
    private _snackBar:MatSnackBar,
    private translate: TranslateService,
    private propertiesService:PropertiesTowers,
     ) { 
    
  }

  
  public gridColumnsConfigurationes: GridColumnsConfiguration = {
    IconValue: "",
    IconColumnName: "",
    hiddenColumnNames: ["id","eventTypeId","severityTypeId","typeAlertId","typeAlert"],
    dateColumns: [
      { columnName: "pauseTo", showTime: false}
    ],
    cardColum: "name",
    cardValues: [
      { place: 0, nombre: 'name', isMainColumn: false },
      { place: 0, nombre: 'typeAlert', isMainColumn: false },
      // { place: 0, nombre: 'cameras', isMainColumn: false },
      { place: 0, nombre: 'isEnabled', isMainColumn: false },
      // { place: 0, nombre: 'pcs', isMainColumn: false },
      { place: 0, nombre: 'pauseTo', isMainColumn: false },
      { place: 0, nombre: 'typeDevice', isMainColumn: false },

      { place: 0, nombre: 'eventType', isMainColumn: false },
      { place: 0, nombre: 'severityType', isMainColumn: false },
      { place: 0, nombre: 'location', isMainColumn: false }    
      
    ]
 

  }



  async ngOnInit(): Promise<void> {
    let sourceDeviceId = localStorage.getItem('sourceDeviceId')

    this.onLanChange = this.translate.onLangChange.subscribe(async s => {
      console.log("idioma",s.lang)
      this.strTranslate = s.lang != undefined ? s.lang : "en";
      let result = await this.getConfigurationsAlerts(sourceDeviceId,this.strTranslate) 
      
    })

    console.log('ssss',this.strTranslate)
    if(this.strTranslate == undefined || this.strTranslate == '') {
      this.strTranslate = 'en'
      let result = await this.getConfigurationsAlerts(sourceDeviceId,this.strTranslate) 
    }

    
    
    
  }

  
  openDialog(): void {
    this.route.navigate(["/updateconfigurationalert"]);
   /* console.log('openDialog');
    
    this.dialog.open(ModalSettingsCameraComponent,
      {
        restoreFocus: false,
        width: '1000px',
        height:'800px'
    });
*/
   
  }

  
  openDialogCreate(): void {
    this.route.navigate(["/saveconfigurationsalert"]);
   /* console.log('openDialog');
    
    this.dialog.open(ModalSettingsCameraComponent,
      {
        restoreFocus: false,
        width: '1000px',
        height:'800px'
    });
*/
   
  }


  public cellClick(obj: any) {
    this.propertiesService.setValueAddOrUpdateDevice(true)
    localStorage.setItem('rowSelectUpdateAlert',JSON.stringify(obj))
    console.log("rowSelectUpdateAlert", obj)  
    this.openDialog()
  }


  private async getConfigurationsAlerts(sourceDeviceId,localCode): Promise<boolean> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetConfigurationsAlerts(sourceDeviceId,localCode).subscribe(
        {
          next: (arraydevices: any={}) => {

            console.log("arraydevices------>", arraydevices)
            //this.fillDataDeviceManagement(arraydevices)
            this.arrayData = arraydevices
       
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

}
